<template>
	<div class="form-wrapper">
		<b-row>
			<b-col cols="12" v-if="errorMessage">
				<p class="text-right text-danger">{{ $t(errorMessage) }}</p>
			</b-col>
			<b-col cols="3">
				<h4 class="font-weight-bold">{{ $t('incomes.create.products-items') }}: <span class="text-danger">*</span></h4>
				<h3>#{{ $t('warehouse.item.total') }}: {{ allTotalCount }}</h3>
				<h5>Кол-во тип товара: {{ items.length }}</h5>
				<h5 v-if="isKirim">{{ $t('incomes.title') }} {{ $t('pos.sum') }}: {{incomeTotal | currency({symbol: computedDepCurrencyName, fractionCount: 2, symbolPosition: 'back'}) }}</h5>
				<h5 v-if="!isKirim">{{ $t('pos.sum') }}: {{priceTotal | currency({symbol: computedDepCurrencyName, fractionCount: 2, symbolPosition: 'back'}) }}</h5>
			</b-col>
			<b-col cols="9">
				<!--Tabs-->
				<b-tabs content-class="mt-3" @input="focusBarcodeInput">
					<b-modal v-model="openViewProductModal" id="modal-lg" hide-footer size="xl"
							 :title="$t('sidebar.warehouse-management.product-view')"
							 no-close-on-backdrop
							 no-close-on-esc
					>
						<!--<span>{{viewItem}}</span>-->

						<b-table class="generalTableClass"
								 striped="striped"
								 bordered="bordered"
								 small="small"
								 fixed="fixed"
								 :items="viewItem"
								 :fields="isKirim ? computedFieldsForIncome : computedFieldsForTransfer"
								 responsive="sm"
						>
							<template slot="index" slot-scope="data">
								{{ data.index + 1 }}
							</template>
							<template slot="incomeUzs" slot-scope="data">
								<b-form-group
									breakpoint="lg"
									class="required"
								>
									<b-input-group size="sm">
										<b-form-input :required="true"
													  size="sm"
													  @focus="$event.target.select()"
													  type="number"
													  v-model.number="data.item.incomingPriceUsd"
													  class="ml-1"
													  :placeholder="$t('incomes.create.incoming-price')"></b-form-input>
										<b-input-group-addon>
											<b-button disabled size="sm">{{ computedDepCurrencyName }}</b-button>
										</b-input-group-addon>
									</b-input-group>
								</b-form-group>
							</template>
							<!-- <template slot="incomeUzs" slot-scope="data">
								{{ data.item.incomeUzs | currency({symbol: computedDepCurrencyName, fractionCount: 2,
								symbolPosition: 'back'}) }}
							</template> -->
						</b-table>
						<div v-if="isKirim"
							 class="row mt-3 createRoleModalButtons justify-content-end"
						>
							<div class="col-4">
								<b-button variant="outline-danger" size="sm" block @click="closeWrappedModal()">
									{{ $t('actions.cancel') }}
								</b-button>
							</div>
							<div class="col-4">
								<b-button variant="outline-success" size="sm" block @click="saveWrappedModal(viewItem)">
									{{ $t('actions.save') }}
								</b-button>
							</div>
						</div>
					</b-modal>
					<b-modal v-model="openModalIfProductHaveMoreThanOnePrice" id="modal-lg-price" hide-footer size="md"
							 :title=" $t('sidebar.pricing.title')">
						<h1>{{ $t('price_different') }}</h1>
						<b-button
							variant="primary"
							size="sm"
							class="float-right ml-2"
							@click="goToNewRoute"
						>
							{{ $t('sidebar.pricing.title') }}
						</b-button>
					</b-modal>
					<!-- SELECT MODAL FOR ITEM WITH DIFFERENT PRICES BEGIN -->
					<b-modal v-model="hasDifferentPrices" hide-footer size="md"
							 :title="$t('price_different')"
							 class="itemWithDifferentPricesModal"
							 :no-close-on-backdrop="true"
							 :no-close-on-esc="true"
							 @close="openCloseModalForItemWithDiffPrices(false)"
					>
						<h6 class="p-0 m-0">{{ $t('please-select-product') }}</h6>
						<div v-for="(item, index) in itemWithDifferentPrices"
							 :key="item.price + index"
							 @click="itemWithDifferentPricesSelected(item)"
							 class="itemWithDifferentPrices"
						>
							<span v-if="item.wrapped">
								{{ index + 1 }}. <strong><b>Уп.</b>  - </strong>{{ item.barcode }} / {{
									item.artikul
								}} / {{ item.colorName }} / {{
									item.size
								}} / {{ item.name ? item.name.substring(0, 30) : '' }} <span v-if="!isKirim"> / <strong>{{
									$t('sale.kol-vo')
								}}:</strong> {{
									item.count1
								}} / <strong>Цена:</strong> {{ item.price }}</span>
							</span>
							<span v-else>
								{{ index + 1 }}. {{ item.artikul }} / {{ item.colorName }} / {{
									item.size
								}} / {{ item.name ? item.name.substring(0, 30) : '' }} <span v-if="!isKirim"> / <strong>{{
									$t('sale.kol-vo')
								}}:</strong> {{
									item.count1
								}} / <strong>Цена:</strong> {{ item.price }}</span>
							</span>
						</div>
					</b-modal>
					<!-- SELECT MODAL FOR ITEM WITH DIFFERENT PRICES END -->
					<b-tab @click="showButtoms1" :title="$t('certificate.search')" active>
						<b-form-group
							breakpoint="lg"
							label-size="sm"
							label-cols="2"
							:label="$t('incomes.create.product')"
							label-for="refName"
							class="required mb-1"
						>
							<multiselect v-model="dropDowns.product.value"
										 :options="itemsNotKirim.length>0 ? itemsNotKirim : goodsForMultiselect"
										 :searchable="true"
										 :show-labels="false"
										 :internal-search="false"
										 :loading="dropDowns.product.loading"
										 :close-on-select="true"
										 label="name"
										 :disabled="!bothDepsSelected"
										 track-by="id"
										 @search-change="loadItems($event)"
										 :placeholder="$t('incomes.create.product')">

								<template slot="singleLabel" slot-scope="props">
									<span v-if="props.option.wrapped">
										<strong><b>Уп.</b>  - </strong>{{ props.option.barcode }} / {{ props.option.artikul }} / {{props.option.colorName }} / {{props.option.size }} / {{ props.option.name ? props.option.name.substring(0, 30) : '' }} / {{ props.option.termOfItem }}
									</span>
									<span v-else>
										{{ props.option.artikul }} / {{props.option.barcode }} / {{ props.option.name ? props.option.name.substring(0, 30) : '' }} / {{ props.option.termOfItem }}
									</span>
								</template>

								<template slot="option" slot-scope="option">
									<span v-if="option.option.wrapped">
										<strong><b>Уп.</b>  - </strong>{{ option.option.barcode }} / {{option.option.artikul }} / {{ option.option.colorName }} / {{option.option.size }} / {{ option.option.name ? option.option.name.substring(0, 30) : '' }}
										<span v-if="!isKirim"> / <strong>{{ $t('sale.kol-vo') }}:</strong> {{option.option.count1 }} / <strong>Цена:</strong> {{ option.option.price }} / <strong>{{ $t('kirim.expirationDate') }}:</strong> {{ option.option.termOfItem ? option.option.termOfItem : '--/--/----' }}</span>
									</span>
									<span v-else>
										{{option.option.barcode }} / {{ option.option.name ? option.option.name.substring(0, 30) : '' }}
										<span v-if="!isKirim"> / <strong>Кол:</strong> {{option.option.count1 }} / <strong>Цена:</strong> {{ option.option.price }} <span v-if="option.option.termOfItem">/ <strong>Срок:</strong> {{ option.option.termOfItem }}</span></span>
										<span v-if="isSpisat"> / {{ option.option.regNumber }}<strong> - {{ option.option.regDate }}</strong></span>
									</span>
								</template>
							</multiselect>
						</b-form-group>
						<!--<div>
							<b-check v-if="isKirim" class="mb-4 pull-right" v-model="convert">{{
								$t('incomes.create.enable-currency') }}
							</b-check>

							<div class="clearfix"></div>
						</div>-->
						<b-row
							v-if="isKirim || isTransfer || isSpisat">
							<!--<b-col v-if="dropDowns.product.value && dropDowns.product.value.forPos" cols="6">
								<b-form-group
									breakpoint="lg"
									label-size="sm"
									label-cols="4"
									:label="$t('incomes.create.incoming-price') + showUnit"
									label-for="refName"
									class="required"
								>
									<b-input-group size="sm">
										<b-form-input :required="true"
													  size="sm"
													  id="inUsd"
													  type="number"
													  @focus="$event.target.select()"
													  v-model.number="newItem.incomingPriceUsd"
													  class="ml-1"
													  :placeholder="$t('incomes.create.incoming-price')"></b-form-input>
										<b-input-group-addon>
											<b-button disabled size="sm">USD</b-button>
										</b-input-group-addon>
									</b-input-group>

								</b-form-group>
							</b-col>-->
							<b-col v-if="dropDowns.product.value && dropDowns.product.value.forPos && isKirim"
								   cols="6"
							>
								<b-form-group
									breakpoint="lg"
									label-size="sm"
									label-cols="4"
									:label="$t('incomes.create.incoming-price') + showUnit"
									label-for="refName"
									class="required"
								>
									<b-input-group size="sm">
										<b-form-input :required="true"
													  size="sm"
													  ref="incomingPriceRef"
													  id="inUzs"
													  @focus="$event.target.select()"
													  type="number"
													  v-model.number="newItem.incomingPriceUsd"
													  @keyup.enter="focusNextInput('incomePrice')"
													  class="ml-1"
													  :placeholder="$t('incomes.create.incoming-price')"></b-form-input>
										<b-input-group-addon>
											<b-button disabled size="sm">{{ computedDepCurrencyName }}</b-button>
										</b-input-group-addon>
									</b-input-group>
								</b-form-group>
							</b-col>
							<!--<b-col cols="6">
								<b-form-group
									breakpoint="lg"
									label-size="sm"
									label-cols="4"
									:label="$t('incomes.create.price') + showUnit"
									label-for="refName"
									class="required"
								>
									<b-input-group size="sm">
										<b-form-input :required="true"
													  size="sm"
													  type="number"
													  id="priceUsd"
													  @focus="$event.target.select()"
													  v-model.number="newItem.priceUsd"
													  class="ml-1"
													  :placeholder="$t('incomes.create.price')"></b-form-input>
										<b-input-group-addon>
											<b-button disabled size="sm">USD</b-button>
										</b-input-group-addon>
									</b-input-group>
								</b-form-group>
							</b-col>-->

							<b-col cols="6" v-if="!isKirim">
								<b-form-group
									breakpoint="lg"
									label-size="sm"
									label-cols="4"
									:label="$t('incomes.create.price') + showUnit"
									label-for="refName"
									class="required"
								>
									<b-input-group size="sm">
										<b-form-input :required="true"
													  size="sm"
													  ref="sellPriceRef"
													  id="priceUzs"
													  type="number"
													  @focus="$event.target.select()"
													  v-model.number="(depSaleType && depSaleType === 'WHOLE') ? newItem.priceWholesale : newItem.priceUzs"
													  @keyup.enter="focusNextInput('sellPrice')"
													  :disabled="!isKirim"
													  class="ml-1"
													  :placeholder="$t('incomes.create.price')"></b-form-input>
										<b-input-group-addon>
											<b-button disabled size="sm">{{ computedDepCurrencyName }}</b-button>
										</b-input-group-addon>
									</b-input-group>
								</b-form-group>
							</b-col>
							<!-- COUNT FOR INCOME -->
							<b-col class="col-6" v-if="isKirim">
								<b-form-group
									breakpoint="lg"
									label-size="sm"
									label-cols="4"
									:label="$t('incomes.create.count')"
									label-for="refName"
									class="required"
								>
									<b-input-group size="sm">
										<b-form-input
											type="number"
											:required="true"
											ref="newItemCountRef"
											size="sm"
											id="count"
											@click="$event.target.select()"
											@focus="$event.target.select()"
											class="ml-1"
											@keyup.enter="addItem"
											v-model.number="newItem.count"
											:placeholder="$t('incomes.create.count')"></b-form-input>
										<b-input-group-addon v-if="unitName">
											<b-button disabled size="sm">{{ unitName }}</b-button>
										</b-input-group-addon>
									</b-input-group>

								</b-form-group>
							</b-col>
						</b-row>

						<b-row>
							<b-col class="col-6" v-if="!isKirim">
								<b-form-group
									breakpoint="lg"
									label-size="sm"
									label-cols="4"
									:label="$t('incomes.create.count')"
									label-for="refName"
									class="required"
								>
									<b-input-group size="sm">
										<b-form-input
											type="number"
											:required="true"
											ref="newItemCountRef"
											size="sm"
											id="count"
											@click="$event.target.select()"
											@focus="$event.target.select()"
											class="ml-1"
											@keydown.enter="addItem"
											v-model.number="newItem.count"
											:placeholder="$t('incomes.create.count')"></b-form-input>
										<b-input-group-addon v-if="unitName">
											<b-button disabled size="sm">{{ unitName }}</b-button>
										</b-input-group-addon>
									</b-input-group>

								</b-form-group>
							</b-col>
							<b-col v-if="newItem.itemId && (sections.includes(section))" cols="3">
								<span class="badge">{{ $t('incomes.balance') }}:</span> {{
									dropDowns.product.value ?
										dropDowns.product.value.count1 : 0
								}} <span>{{
									unitName
								}}</span>
							</b-col>
							<div class="col-sm-6" v-if="isKirim">
								<b-form-group
									breakpoint="lg"
									label-size="sm"
									label-cols="4"
									label="Cрок годности"
									label-for="refName"
									class="required"
								>
									<!--<label class="lebeltop">{{$t('expenses.type')}}</label>-->
									<date-picker
										style="margin-left: -9px"
										v-model="newItem.termOfItem"
										size="sm"
										lang="ru"
										:placeholder=" $t('kirim.expirationDate')"
										valueType="format"
										format="DD-MM-YYYY"
									></date-picker>
									<!--										<b-input-group-addon>-->
									<!--											<b-button size="sm" >-->
									<!--												<i class="fa fa-calendar"></i>-->
									<!--											</b-button>-->
									<!--										</b-input-group-addon>-->
								</b-form-group>
							</div>

<!--							<b-col cols="1">-->

<!--								<b-button v-if="isWrappedComputed && newItem.itemId" block size="sm" type="button"-->
<!--										  variant="outline-primary"-->
<!--										  @click="viewProduct(newItem)">-->
<!--									<i style="color: black" class="fa fa-eye"></i></b-button>-->

<!--								<b-button v-else-if="isWrappedComputed && lastAddedItem" block size="sm" type="button"-->
<!--										  variant="outline-primary"-->
<!--										  @click="viewProduct(lastAddedItem)">-->
<!--									<i style="color: black" class="fa fa-eye"></i></b-button>-->
<!--							</b-col>-->

						</b-row>
						<div class="form-group">
							<b-button type="button"
									  size="sm"
									  :disabled="disableButton"
									  variant="outline-primary"
									  @click="addItem"
									  class="mr-4"
							>
								{{ $t('incomes.create.add-item') }}
							</b-button>
							<span v-if="successBarcode && lastAddedItem"><span
								class="text-success">{{ $t('last-product') }}: </span><strong> &nbsp;{{
									lastAddedItem.artikul
								}} / {{ lastAddedItem.color }} / {{ lastAddedItem.size }} / {{
									lastAddedItem.barcode
								}}</strong><br></span>
							<span v-if="itemFieldsNotFilled"
								  class="ml-3 text-danger">{{ $t('incomes.create.notFilledItem') }}</span>
						</div>
					</b-tab>
					<b-tab v-if="!isSpisat" @click="showButtoms1" :title="$t('goods.barcode')">
						<b-row>
							<b-col class="col-12">
								<b-input-group
									breakpoint="lg"
									label-size="sm"
									label-cols="2"
									:label="$t('incomes.create.barcode')"
									label-for="barcode"
									label-class="ml-1"
									class="required"
									size="sm"
								>
									<b-input-group-text slot="prepend">
								<span class="input-group-addon">
									<i class="fa fa-barcode"></i>
								</span>
									</b-input-group-text>
									<b-form-input
										:required="true"
										size="sm"
										autofocus
										id="barcodeInput"
										ref="barcodeInput"
										autocomplete="off"
										onClick="setSelectionRange(0, value.length)"
										v-model="barcodeInputValue"
										:placeholder="$t('incomes.create.barcode')">
									</b-form-input>
									<b-input-group-text slot="append" id="for-barcode">
										<b-input-group-addon style="cursor: pointer;"
															 class="input-group-addon barcode-refresh"
															 @click="clearBarcode"
										>
											<i class="fa fa-times"></i>
										</b-input-group-addon>
									</b-input-group-text>
								</b-input-group>
							</b-col>
							<!--<b-col class="col-6" align-h="end">
								<b-check v-if="isKirim" class="mb-2 mt-2" v-model="convert">{{
									$t('incomes.create.enable-currency') }}
								</b-check>
							</b-col>-->
							<template v-if="false">
								<b-col class="col-12">
									<h6 class="mb-2 mt-2">{{ itemWithBarcode.artikul }} / {{
											itemWithBarcode.colorName
										}} / {{ itemWithBarcode.size }} / {{
											itemWithBarcode.name ?
												itemWithBarcode.name.substring(0, 30) : ''
										}} /
										<strong>{{
												itemWithBarcode.barcode
											}}</strong></h6>
								</b-col>
								<b-col class="col-6">
									<b-form-group
										breakpoint="lg"
										label-size="sm"
										label-cols="4"
										:label="$t('incomes.create.count')"
										label-for="barcodeItemCount"
										class="required"
									>
										<b-input-group size="sm">
											<b-form-input
												type="number"
												:required="true"
												size="sm"
												ref="barcodeItemCount"
												id="barcodeItemCount"
												@click="$event.target.select()"
												class="ml-1"
												@keyup.enter.native="barcodeItemCountEntered"
												v-model.number="newItem.count"
												:placeholder="$t('incomes.create.count')"></b-form-input>
											<b-input-group-addon v-if="unitName">
												<b-button disabled size="sm">{{ unitName }}</b-button>
											</b-input-group-addon>
										</b-input-group>
									</b-form-group>
								</b-col>
							</template>
							<template v-else-if="barcodeError">
								<b-col class="col-12 mt-2">
									<span class="text-danger">{{ $t('warehouse.document.itemNotFound') }} </span> <span><b> {{
										lastEnteredBarcode
									}}</b></span>
								</b-col>

							</template>
							<template v-else-if="successBarcode && lastAddedItem">
								<b-col class="col-9 mt-2">
									<span class="text-success">{{ $t('last-product') }}: </span> <b> &nbsp;{{
										lastAddedItem.artikul
									}} / {{ lastAddedItem.color }} / {{ lastAddedItem.size }} / {{
										lastAddedItem.barcode
									}}</b>
								</b-col>
								<b-col cols="1">

									<b-button v-if="isWrappedComputed" block size="sm" type="button"
											  variant="outline-primary"
											  @click="viewProduct(lastAddedItem)">
										<i style="color: black" class="fa fa-eye"></i></b-button>
								</b-col>
								<!--<b-col v-if="sections.includes(section)" class="col-3 mt-2 pl-0 pr-0">
									<span class="badge">{{ $t('incomes.balance') }}:</span> {{ balance > 0 ? balance - 1 : 0 }} <span>{{ unitName
								}}</span>
								</b-col>-->
							</template>
							<!--<template v-else>
								<b-col v-if="sections.includes(section)" class="col-3 mt-2">
									<span class="badge">{{ $t('incomes.balance') }}:</span> {{ balance > 0 ? balance - 1 : 0 }} <span>{{ unitName
								}}</span>
								</b-col>
							</template>-->

						</b-row>
					</b-tab>
					<b-tab @click="showButtoms" :title="$t('excel-export.title-barcode')" v-if="isSpisat && isAdmin" :disabled="status == 'RECOUNT' ? true : false">
						<div>
							<h5 style="color: red;">{{ $t('instructionMessageWriteOffBarcode') }}</h5>
							<br/>
							<b-row>
								<b-col cols="9 d-flex justify-content-end">
									<b-form-file v-model="newItem.excelBarcodeFile" :browse-text="$t('excel-export.view-excel')" :placeholder="$t('excel-export.select-file')" drop-placeholder="Перетащите файл сюда ..." size="sm" name="fileBarcode" style="width: 88%;" v-validate="{required:true}" :state="fileSelected" accept=".xls, .xlsx">
										<template slot="file-name" slot-scope="{ names }">
											<b-badge variant="dark">{{ names[0] }}</b-badge>
											<b-badge v-if="names.length > 1" variant="dark" class="ml-1">+ {{ names.length - 1 }} More files</b-badge>
										</template>
									</b-form-file>
								</b-col>
								<b-col cols="3 d-flex justify-content-end" style="align-self: center;"><a style="font-size: 16px;" :href="`${publicPath}excel/товары списание по штрихкоду.xlsx`" download>{{ $t('excel.title') }}</a></b-col>
							</b-row>
							<br/>
							<b-row>
								<b-col cols="6">
									<p class="text-danger" v-if="fileNotSelectMessage"> Пожалуйста выберите файл</p>
								</b-col>
								<b-col cols="2">
									<b-button @click="openCancelExcelModal" class="pull-right" :disabled="isXlsDisabled" variant="danger">
										{{ $t('actions.cancel') }}
									</b-button>
								</b-col>
								<b-col cols="4">
									<b-button @click="uploadFileToServerByBarcode" class="pull-right" :disabled="isXlsDisabled" variant="primary">
										{{ $t('excel-export.download-file') }}
									</b-button>
								</b-col>
							</b-row>
						</div>
					</b-tab>
					<b-tab @click="showButtoms" :title="$t('excel-export.title')" v-if="isKirim||isSpisat" :disabled="status == 'RECOUNT' ? true : false">
						<div>
							<h5 style="color: red;">{{ isKirim?$t('instructionMessage'):$t('instructionMessage1') }}</h5>
							<br/>
							<b-row>
								<b-col cols="9 d-flex justify-content-end">
									<b-form-file v-model="newItem.excelFile" :browse-text="$t('excel-export.view-excel')" :placeholder="$t('excel-export.select-file')" drop-placeholder="Перетащите файл сюда ..." size="sm" name="file" style="width: 88%;"  v-validate="{required:true}" :state="fileSelected" accept=".xls, .xlsx">
										<template slot="file-name" slot-scope="{ names }">
											<b-badge variant="dark">{{ names[0] }}</b-badge>
											<b-badge v-if="names.length > 1" variant="dark" class="ml-1">+ {{ names.length - 1 }} More files</b-badge>
										</template>
									</b-form-file>
								</b-col>
								<b-col cols="3 d-flex justify-content-end" style="align-self: center;"><a style="font-size: 16px;" :href="isKirim?`${publicPath}excel/Приходные товары.xlsx`:`${publicPath}excel/товары списание.xlsx`" disabled download>{{ $t('excel.title') }}</a></b-col>
							</b-row>
							<br/>
							<b-row>
								<b-col cols="6">
									<p class="text-danger" v-if="fileNotSelectMessage"> Пожалуйста выберите файл</p>
								</b-col>
								<b-col cols="2">
									<b-button @click="openCancelExcelModal" class="pull-right" :disabled="isXlsDisabled" variant="danger">
										{{ $t('actions.cancel') }}
									</b-button>
								</b-col>
								<b-col cols="4">
									<b-button @click="uploadFileToServer" class="pull-right" :disabled="isXlsDisabled" variant="primary">
										{{ $t('excel-export.download-file') }}
									</b-button>
								</b-col>
							</b-row>
						</div>
					</b-tab>
					<b-tab @click="showButtoms" :title="$t('excel-export.title')" v-if="isTransfer">
						<div>
							<b-row>
								<b-col cols="9 d-flex justify-content-end">
									<b-form-file v-model="excelFile" :browse-text="$t('excel-export.view-excel')" :placeholder="$t('excel-export.select-file')" drop-placeholder="Перетащите файл сюда ..." size="sm" name="file" style="width: 88%;" v-validate="{required:true}" :state="fileSelected" accept=".xls, .xlsx">
										<template slot="file-name" slot-scope="{ names }">
											<b-badge variant="dark">{{ names[0] }}</b-badge>
											<b-badge v-if="names.length > 1" variant="dark" class="ml-1">+ {{ names.length - 1 }} More files</b-badge>
										</template>
									</b-form-file>
								</b-col>
								<b-col cols="3 d-flex justify-content-end" style="align-self: center;"><a style="font-size: 16px;" :href="`${publicPath}excel/перемещение.xlsx`" disabled download>{{ $t('excel.title') }}</a></b-col>
							</b-row>
							<br/>
							<b-row>
								<b-col cols="6">
									<p class="text-danger" v-if="fileNotSelectMessage"> Пожалуйста выберите файл</p>
								</b-col>
								<b-col cols="2">
									<b-button @click="openCancelExcelModal" class="pull-right" :disabled="isXlsDisabled" variant="danger">{{ $t('actions.cancel') }}</b-button>
								</b-col>
								<b-col cols="4">
									<b-button @click="uploadFileToServer" class="pull-right" :disabled="isXlsDisabled" variant="primary">{{ $t('excel-export.download-file') }}</b-button>
								</b-col>
							</b-row>
						</div>
					</b-tab>
					<b-tab @click="showButtoms" :title="$t('Артикул')" v-if="isKirim">
						<div>
							<h5 style="color: red;">{{ $t('instructionMessage2')}}</h5>
							<br/>
							<b-row>
								<b-col cols="9 d-flex justify-content-end">
									<b-form-file v-model="newItem.vendor" :browse-text="$t('excel-export.view-excel')" :placeholder="$t('excel-export.select-file')" drop-placeholder="Перетащите файл сюда ..." size="sm" name="file" style="width: 88%;" v-validate="{required:true}" :state="fileSelected" accept=".xls, .xlsx">
										<template slot="file-name" slot-scope="{ names }">
											<b-badge variant="dark">{{ names[0] }}</b-badge>
											<b-badge v-if="names.length > 1" variant="dark" class="ml-1">+ {{ names.length - 1 }} More files</b-badge>
										</template>
									</b-form-file>
								</b-col>
								<b-col cols="3 d-flex justify-content-end" style="align-self: center;"><a style="font-size: 16px;" :href="`${publicPath}excel/Приходные товары с артикулем.xlsx`" disabled download>{{ $t('excel.title') }}</a></b-col>
							</b-row>
							<br/>
							<b-row>
								<b-col cols="6">
									<p class="text-danger" v-if="fileNotSelectMessage"> Пожалуйста выберите файл</p>
								</b-col>
								<b-col cols="2">
									<b-button @click="openCancelExcelVendorModal" class="pull-right" :disabled="isXlsDisabled" variant="danger">
										{{ $t('actions.cancel') }}
									</b-button>
								</b-col>
								<b-col cols="4">
									<b-button @click="uploadFileToVendorServer" class="pull-right" :disabled="isXlsDisabled" variant="primary">
										{{ $t('excel-export.download-file') }}
									</b-button>
								</b-col>
							</b-row>
						</div>
					</b-tab>
				</b-tabs>
				<!--Tabs-->
			</b-col>
			<b-modal v-model="cancelExcelModal" @ok="cancelLastUploaded(true)" ok-title="Да" cancel-title="Отмена">
				<h4>{{ $t('excel-export.sureMsg') }}</h4>
			</b-modal>
			<b-modal v-model="cancelExcelVendorModal" @ok="cancelVendorUploaded(true)" ok-title="Да" cancel-title="Отмена">
				<h4>{{ $t('excel-export.sureMsg') }}</h4>
			</b-modal>
		</b-row>
		<div v-if="loading" class="spinner-wrapper">
			<b-spinner/>
		</div>
	</div>
</template>

<script>
import {errorAndSuccessSounds} from '../../../../mixins/errorAndSuccessSounds';
import {mapActions, mapState} from 'vuex'
import WhDocument from "../../../../services/wh-document.service";
import Multiselect from 'vue-multiselect'
import Vue from 'vue'
import MaskedInput from "vue-masked-input";
import { convertRuToEn } from '@/utils/helper';

const initial = {
	id: null,
	documentId: null,
	itemId: null,
	itemName: null,
	count: 1,
	termOfItem: null,
	incomingPriceUsd: null,
	currencyId: null,
	priceUsd: null,
	//incomingPriceUzs: null,
	priceUzs: null,
	providerId: null,
	providerName: null,
	wrapped: false,
	inventoryNum: null,
	sectorId: null,
};

export default {
	name: 'CreateItems',
	mixins: [errorAndSuccessSounds],
	props: {
		mode: {
			type: String,
			default: 'create'
		},
		items: {
			type: Array,
			default: () => []
		},
		status: {type: '', default: ''},
		allTotalCount: {type: Number},
		incomeTotal: {type: Number},
		priceTotal: {type: Number},
		documentId: {},
		department: {},
		depSaleTypeOld: {type: String, default: ''},
		toDepartmentId: {type: Number},
		groupId: {type: Number},
		section: {
			type: String,
			default: 'KIRIM'
		},
		currencyRate: {
			type: Number,
			default: -1
		},
		depCurrencyName: {
			type: String,
			default: ''
		},
		incomeCurrency: {
			type: Object,
			default: () => {
				name: ''
			}
		},
		toDepartmentObject: {
			type: Object,
			default: () => {
			}
		}
	},

	components: {
		Multiselect,
		MaskedInput,
		SelectOrCreate: () => import('../../../components/SelectOrCreate')
	},

	created() {
		if (!this.isTransfer) {
			this.bothDepsSelected = true;
		} else {
			if (this.department && this.toDepartmentId) {
				this.bothDepsSelected = true;
			}
		}
		this.$barcodeScanner.init(this.barcodeScanned);
		this.loadItems(' ');
		if (this.sections.includes(this.section)) {
			this.pushable = false;
		}
		if (this.department) {
			this.loadSector(this.department)
		}
	},
	destroyed() {
		this.$barcodeScanner.destroy();
	},

	data() {
		return {
			showCancelUpload: false,
			hasDifferentPrices: false,
			cancelExcelModal: false,
			cancelExcelVendorModal: false,
			chooseBarcode: false,
			barcodes: {},
			computedFieldsForIncome: [
				{
					key: 'artikul',
					label: this.$t('goods.artikul'),
					'class': 'incomeItemArtikul',
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: 'colorName',
					label: this.$t('goods.color'),
					'class': 'incomeItemArtikul',
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: 'size',
					label: this.$t('goods.size'),
					'class': 'incomeItemSize',
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: 'name',
					label: this.$t('incomes.create.product'),
					'class': 'not-first',
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: 'amount',
					label: this.$t('incomes.create.count'),
					'class': 'td-30',
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: 'termOfItem',
					label: this.$t('termOfItem'),
					'class': 'td-30',
					sortable: true,
					visible: true,
					changebale: true
				},

				{
					key: 'barcode',
					label: this.$t('goods.barcode'),
				},
				{
					key: 'incomeUzs',
					label: 'Цена (приход)',
					'class': 'width18',
					visible: true,
					changebale: true
				},
			],
			computedFieldsForTransfer: [
				{
					key: 'artikul',
					label: this.$t('goods.artikul'),
					'class': 'incomeItemArtikul',
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: 'color',
					label: this.$t('goods.color'),
					'class': 'incomeItemArtikul',
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: 'size',
					label: this.$t('goods.size'),
					'class': 'incomeItemSize',
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: 'name',
					label: this.$t('incomes.create.product'),
					'class': 'not-first',
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: 'amount',
					label: this.$t('incomes.create.count'),
					'class': 'td-30',
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: 'termOfItem',
					label: this.$t('termOfItem'),
					'class': 'td-30',
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: 'barcode',
					label: this.$t('goods.barcode'),
				},
				{
					key: 'priceUzs',
					label: `${this.$t('incomes.create.price')} (Сумма)`,
					'class': 'td-30',
					sortable: true,
					visible: true,
					changebale: true
				},


			],
			openModalIfProductHaveMoreThanOnePrice: false,
			disableButton: false,
			bothDepsSelected: false,
			publicPath: process.env.BASE_URL,
			loading: false,
			itemFieldsNotFilled: false,
			noDepartment: false,
			fileSelected: null,
			fileNotSelectMessage: false,
			barcodeFn: false,
			isBarcodeScanned: false,
			dropDowns: {
				product: {
					items: [],
					value: null,
					loading: false,
					search: {
						page: 1,
						limit: 10,
						attributes: [{
							field: 'name',
							value: '',
							option: 'CONTAINS'
						}]
					}
				},
			},
			dropdowns: {
				sector: {
					items: [],
					value: null,
				}
			},
			lastEnteredBarcode: null,
			lastAddedItem: null,
			openViewProductModal: false,
			successBarcode: null,
			newItem: {
				id: null,
				documentId: null,
				itemId: null,
				itemName: null,
				count: 1,
				incomingPriceUsd: null,
				currencyId: null,
				priceUsd: null,
				incomingPriceUzs: null,
				priceWholesale: null,
				price: null,
				priceUzs: null,
				providerId: null,
				providerName: null,
				inventoryNum: null,
				wrapped: false,
				sectorId: null,
				barcode: null,
				excelFile: '',
				excelBarcodeFile: '',
				vendor:'',
				termOfItem: '',
			},
			excelFile: '',
			excelBarcodeFile: '',
			vendor:'',
			barcodeInputValue: '',
			timeout: null,
			unitName: '',
			viewItem: [],
			convert: false,
			isWrapped: false,
			// balance: 0,
			pushable: true,
			errorMessage: null,
			sections: ['CHIQIM', 'KOCHIRISH', 'SPISAT'],
			isExcelDisabled: false
		}
	},

	methods: {
		// selectedItemBarcode($event) {
		// 	if ($event.multiBarcodes.length > 1) {
		// 		this.barcodes = $event.multiBarcodes
		// 		this.chooseBarcode = true
		// 	}
		// },
		// saveBarcode(item) {
		// 	this.dropDowns.product.value.multiBarcode = item.barcode
		// 	this.chooseBarcode = false
		// },
		showButtoms1() {
			this.showCancelUpload = false
		},
		showButtoms() {
			this.showCancelUpload = true
		},
		async itemWithDifferentPricesSelected(item) {
			await this.$store.commit('goods/setItemWithBarcode', item);
			this.isWrapped = this.itemWithBarcode.wrapped
			this.unitName = this.itemWithBarcode.unitName;
			this.newItem.itemId = this.itemWithBarcode.id;
			this.newItem.itemName = this.itemWithBarcode.name;
			this.newItem.count = 1;
			this.newItem.wrapped = this.itemWithBarcode.wrapped;
			this.newItem.barcode = this.itemWithBarcode.barcode;
			// this.newItem.termOfItem = this.itemWithBarcode.termOfItem;
			this.newItem.artikul = this.itemWithBarcode.artikul;
			this.newItem.color = this.itemWithBarcode.colorName;
			this.newItem.size = this.itemWithBarcode.size;
			this.newItem.docId = this.itemWithBarcode.docId
			if (this.newItem.wrapped) {
				await this.wrappedItemSelected(this.newItem);
				if (this.isKirim) {
					this.newItem.wrappedItems = this.viewItem;
				} else if (this.isTransfer) {
					this.newItem.whWrappedItems = this.viewItem;
				}
			}
			await this.loadLastPrice(this.itemWithBarcode, 'fromBarcodeFn');
			await this.$store.commit('goods/setItemWithDifferentPrices', []);
			this.openCloseModalForItemWithDiffPrices(false);
			this.$refs.barcodeInput.focus();
		},
		parseAndFilterStringToArray(stringArray) {
			let nullRemovedString = stringArray.replace(new RegExp('NULL', 'gi'), 0);
			let parsed = JSON.parse(nullRemovedString);
			let filteredResult = parsed.filter(el => {
				if (el !== null && el !== 0 && el !== 'null' && el !== '0') {
					return el;
				}
			})
			if (filteredResult.length == 0) {
				filteredResult.push(0);
			}
			return filteredResult;
		},
		async wrappedItemSelected(item) {
			let obj = {}
			obj.itemId = item.itemId;
			if (this.customDepartments.section == 'KOCHIRISH') {
				obj.departmentId = this.customDepartments.fromDepartmentId;
			}
			if (this.customDepartments.section == 'KIRIM') {
				obj.departmentId = this.customDepartments.toDepartmentId;
			}
			if (this.viewItem.length > 0) {
				if (this.viewItem[0].parentId !== item.itemId) {
					if (this.isKirim) {
						await WhDocument.getViewPRoductItems(obj)
							.then(response => {
								this.viewItem = response.data;
							}).then(payload => {
								this.saveWrappedModal(this.viewItem);
							}).catch(e => {
								this.viewItem = [];
							})
					} else if (this.isTransfer) {
						let payload = {
							itemId: item.itemId,
							docId: item.docId
						}
						await this.getWrappedItemsById(payload)
						this.viewItem = this.lastWrappedItems;
						this.saveWrappedModal(this.viewItem);
					}
				} else {
					this.saveWrappedModal(this.viewItem);
				}
			} else {
				if (this.isKirim) {
					await WhDocument.getViewPRoductItems(obj)
						.then(response => {
							this.viewItem = response.data;
						}).then(payload => {
							this.saveWrappedModal(this.viewItem);
						}).catch(e => {
							this.viewItem = [];
						})
				} else if (this.isTransfer) {
					let payload = {
						itemId: item.itemId,
						docId: item.docId
					}
					await this.getWrappedItemsById(payload)
					this.viewItem = this.lastWrappedItems;
					this.saveWrappedModal(this.viewItem);

				}
			}
		},
		closeWrappedModal() {
			this.openViewProductModal = false;
		},
		saveWrappedModal(viewItem) {
			this.newItem.incomingPriceUsd = 0;
			viewItem.forEach(el => {
				if (el.incomingPriceUsd) {
					this.newItem.incomingPriceUsd += el.incomingPriceUsd > 0 ? el.incomingPriceUsd * el.amount : 0;
				} else {
					this.newItem.incomingPriceUsd += 0;
				}
			})
			this.openViewProductModal = false;
		},
		openModalPriceDifference() {
			this.openModalIfProductHaveMoreThanOnePrice = true;
		},
		openCloseModalForItemWithDiffPrices(boolean) {
			if (!boolean) {
				this.$store.commit('goods/setItemWithDifferentPrices', []);
			}
			this.hasDifferentPrices = boolean;
		},
		goToNewRoute() {
			this.openModalIfProductHaveMoreThanOnePrice = false;
			window.open(window.location.origin + "/" + "point-of-sale/prices", '_blank');
		},

		async loadSector(id) {
			await WhDocument.getSectorByDepartmentId(id).then(response => {
				this.dropdowns.sector.items = response;
				this.$store.commit('warehouse/setSector', this.dropdowns.sector.items);
			})
		},
		async viewProduct(item) {
			let obj = {}
			obj.itemId = item.itemId;
			if (this.customDepartments.section == 'KOCHIRISH' || this.customDepartments.section == 'SPISAT') {
				obj.departmentId = this.customDepartments.fromDepartmentId;
			}
			if (this.customDepartments.section == 'KIRIM') {
				obj.departmentId = this.customDepartments.toDepartmentId;
			}
			if (this.isKirim) {
				WhDocument.getViewPRoductItems(obj)
					.then(response => {
						this.viewItem = response.data;
					}).catch(e => {
					this.viewItem = [];
				})
			} else {
				let payload = {
					itemId: item.itemId,
					docId: item.docId
				}
				await this.getWrappedItemsById(payload)

				this.viewItem = this.lastWrappedItems;
				// WhDocument.getWrapped(obj)
				// 	.then(response => {
				// 		this.viewItem = response.data;
				// 	}).catch(e => {
				// 		this.viewItem = [];
				// 	})
			}
			this.openViewProductModal = true;
		},

		...mapActions('goods', [
			'fetchGoodsWithKeyword', 'fetchItemWithBarcode', 'fetchItemWithBarcodeNotIncome', 'getWrappedItemsById',
			'fetchItemWithBarcodeForDepBySaleType', 'fetchItemWithBarcodeScannerForDepBySaleType'
		]),
		...mapActions('warehouse', [
			'lastPriceByItemId', 'loadBalance', 'getListByProductsNotKirim',
			'setDefaultToIsNotKrim', 'loadNewBalance', 'changePriceNotDifferent',
			'uploadExcelForIncome','uploadExcelForVendorIncome','uploadExcelForSpisat','uploadExcelForSpisatByBarcode', 'uploadExcelForTransfer', 'getItemsForDepBySaleType', 'getItemsForDepBySaleTypeTransfer', 'getItemsForDepBySaleTypeOff'
		]),
		clearBarcode() {
			this.barcodeInputValue = '';
			this.focusBarcodeInput(1);
		},
		/**
		 *  Load and search items
		 * @param $event
		 * @param by
		 */
		async loadItems($event, by = 'name') {
			this.dropDowns.product.loading = true;
			/*if ($event !== null) {
				this.dropDowns.product.search.attributes[0].value = $event;
			}*/
			if (this.isKirim) {
				await this.fetchGoodsWithKeyword($event);

			} else if (this.isTransfer) {
				if ($event.toString().trim() == '') {
					$event = null;
				}
				let obj = {};
				obj.keyword = $event;
				obj.depId = this.customDepartments.fromDepartmentId;
				obj.depSaleType = this.depSaleType;
				obj.subCategoryId = this.groupId ? this.groupId : 'null'
				if (this.depSaleType) {
					await this.getItemsForDepBySaleTypeTransfer(obj);
				}
			} else if (this.department) {
				if ($event.toString().trim() == '') {
					$event = null;
				}
				let obj = {};
				obj.keyword = $event;
				obj.depId = this.customDepartments.fromDepartmentId;
				obj.depSaleType = this.depSaleType;
				// let str = "keyword=" + $event + "&depId=" + this.customDepartments.fromDepartmentId;
				if (this.isTransfer) {
					if (this.depSaleType) {
						await this.getItemsForDepBySaleType(obj);
					}
					// else {
					// 	if (this.toDepartmentObject.saleType) {
					// 		obj.depSaleType = this.toDepartmentObject.saleType;
					// 		this.getItemsForDepBySaleType(obj);
					// 	}
					// }
				} else {
					await this.getItemsForDepBySaleTypeOff(obj);
				}
				//this.getListByProductsNotKirim(obj);
			}

			if (this.withKeywordError) {
				this.$vs.notify({
					text: this.withKeywordError,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				})
			}
			this.dropDowns.product.loading = false;
		},

		/**
		 *  Add Warehouse item
		 */
		async addItem(eventOrFromWhere) {
			if (!this.department) {
				this.$vs.notify({
					text: this.$t('department.choose-department'),
					color: 'warning',
					icon: 'close',
					position: 'top-right'
				});
				return 0;
			}
			if (this.dropDowns.product.value || this.itemWithBarcode) {
				if (this.isKirim && (this.newItem.incomingPriceUsd == '' || !this.newItem.incomingPriceUsd)) {
					/*this.$vs.notify({
						text: this.$t('incomePriceError'),
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
					return 0;*/
					this.newItem.incomingPriceUsd = 0;
				}
				this.loading = true;
				this.newItem.documentId = this.documentId;
				if (this.isBarcodeScanned) {
					this.newItem.inventoryNum = this.itemWithBarcode ? this.itemWithBarcode.count1 : 0;
				} else {
					this.newItem.inventoryNum = this.dropDowns.product.value ? this.dropDowns.product.value.count1 : 0;
				}
				this.newItem.count = (this.newItem.count && this.newItem.count > 0) ? this.newItem.count : 1;
				if (this.dropDowns.product.value) {
					if (!this.isKirim && this.newItem.count > this.dropDowns.product.value.count1) {
						this.newItem.count = this.dropDowns.product.value.count1;
					}
				}

				if (this.newItem.count <= 0) {
					this.$vs.notify({
						time: 1200,
						title: "Количество",
						text: 'Проверьте количество товара!',
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
					if (this.$refs.newItemCountRef) {
						this.$refs.newItemCountRef.focus();
					}
					this.loading = false;
					return 0;
				}
				this.newItem.toDepartmentId = this.toDepartmentId
				this.newItem.fromDepartmentId = this.department
				this.newItem.mxikCode = this.dropDowns.product.value.mxikCode?this.dropDowns.product.value.mxikCode:null;
				let findIndex = this.items.findIndex(el => {
					if (this.isKirim) {
						return el.itemId == this.newItem.itemId && el.termOfItem == this.newItem.termOfItem && el.incomingPriceUsd == this.newItem.incomingPriceUsd;
					} else if (this.isSpisat) {
						let tempBoolean = el.itemId == this.newItem.itemId && el.regNumber == this.newItem.regNumber && el.termOfItem == this.newItem.termOfItem && (el.price ? el.price == this.newItem.price : ((this.depSaleType && this.depSaleType == 'WHOLE') ? el.priceWholesale == this.newItem.price : el.priceUzs == this.newItem.price));
						return tempBoolean;
					} else {
						let tempBoolean = el.itemId == this.newItem.itemId && el.termOfItem == this.newItem.termOfItem && (el.price ? el.price == this.newItem.price : ((this.depSaleType && this.depSaleType == 'WHOLE') ? el.priceWholesale == this.newItem.price : el.priceUzs == this.newItem.price));
						return tempBoolean;
					}
				});
				if (findIndex >= 0) {
					// let oldCount = this.items[findIndex].count;
					if ((this.items[findIndex].count + this.newItem.count <= this.items[findIndex].realBalance) || this.section == 'KIRIM') {
						if (this.isTransfer || this.isKirim || this.isSpisat) {
							if (eventOrFromWhere !== 'fromBarcodeFn') {
								this.newItem.barcode = this.dropDowns.product.value.barcode;
								this.newItem.artikul = this.dropDowns.product.value.artikul;
								this.newItem.color = this.dropDowns.product.value.colorName;
								this.newItem.size = this.dropDowns.product.value.size;
								this.newItem.termOfItem = this.newItem.termOfItem ? this.newItem.termOfItem : this.dropDowns.product.value.termOfItem;
								this.newItem.multiBarcodes = this.dropDowns.product.value.multiBarcodes;
								this.newItem.unitName = this.dropDowns.product.value.unitName;
								this.newItem.docId = this.isKirim ? this.dropDowns.product.value.docId : JSON.parse(this.dropDowns.product.value.docIds)[0];
							}
							this.newItem.currencyId = this.incomeCurrency.id ? this.incomeCurrency.id : null;
							let temp = Object.assign({}, this.newItem);
							this.lastAddedItem = Object.assign({}, this.newItem);
							this.successBarcode = true;
							this.$store.commit('goods/setBarcodeError', false);
							this.$emit('success', temp);
							if (this.newItem.wrapped) {
								this.isWrapped = true;
							} else {
								this.isWrapped = false;
							}
							Object.assign(this.newItem, initial);
							this.newItem.priceUsd = null;
							this.newItem.priceUzs = null;
							this.newItem.count = 1;
							this.newItem.incomingPriceUsd = null
							this.dropDowns.product.value = null;
							this.incomingPriceUzs = null;
							this.loading = false;
						} else {
							this.newItem.id = this.items[findIndex].id;
							await WhDocument.updateItem(this.newItem).then(response => {
								this.lastAddedItem = Object.assign({}, response.data);
								this.successBarcode = true;
								this.$store.commit('goods/setBarcodeError', false);
								response.data.inventoryNum = this.dropDowns.product.value.count1;
								this.$emit('success', response.data);
								if (this.newItem.wrapped) {
									this.isWrapped = true;
								} else {
									this.isWrapped = false;
								}
								Object.assign(this.newItem, initial);
								this.newItem.priceUsd = null;
								this.newItem.priceUzs = null;
								this.newItem.count = 1;
								this.newItem.incomingPriceUsd = null
								this.dropDowns.product.value = null;
								this.incomingPriceUzs = null;
								this.loading = false;
							}).catch((error) => {
								this.lastAddedItem = null;
								this.successBarcode = false;
								this.loading = false;
							})
						}
					} else {
						this.$emit('changeRowVariant', findIndex);
						this.loading = false;
						this.$vs.notify({
							title: "Количество",
							text: 'Проверьте количество товаров!',
							color: 'warning',
							icon: 'close',
							position: 'top-right'
						});
					}
				} else {
					if (this.isTransfer || this.isKirim || this.isSpisat) {
						if (this.isKirim || this.isTransfer) {
							if (!this.newItem.wrappedItems) {
								if (this.viewItem.length > 0) {
									if (this.viewItem[0].parentId !== this.newItem.itemId) {
										await this.wrappedItemSelected(this.newItem);
									}
								}
							} else if (this.newItem.wrappedItems.length == 0) {
								if (this.viewItem.length > 0) {
									if (this.viewItem[0].parentId !== this.newItem.itemId) {
										await this.wrappedItemSelected(this.newItem);
									}
								}
							}
						}
						if (eventOrFromWhere !== 'fromBarcodeFn') {
							this.newItem.barcode = this.dropDowns.product.value.barcode;
							this.newItem.artikul = this.dropDowns.product.value.artikul;
							this.newItem.color = this.dropDowns.product.value.colorName;
							this.newItem.size = this.dropDowns.product.value.size;
							this.newItem.incomeDocId = this.dropDowns.product.value.incomeDocId;
							this.newItem.regNumber = this.dropDowns.product.value.regNumber;
							this.newItem.termOfItem = this.newItem.termOfItem ? this.newItem.termOfItem : this.dropDowns.product.value.termOfItem;
							this.newItem.multiBarcodes = this.dropDowns.product.value.multiBarcodes;
							this.newItem.unitName = this.dropDowns.product.value.unitName;
							this.newItem.docId = this.isKirim ? this.dropDowns.product.value.docId : JSON.parse(this.dropDowns.product.value.docIds)[0];
							if (this.dropDowns.product.value) {
								if (this.dropDowns.product.value.wrapped) {
									if (this.isKirim) {
										this.newItem.wrappedItems = this.viewItem;
									} else if (this.isTransfer) {
										this.newItem.whWrappedItems = this.viewItem;
									}
								}
							}
						}
						this.newItem.currencyId = this.incomeCurrency.id ? this.incomeCurrency.id : null;
						let temp = Object.assign({}, this.newItem);
						this.lastAddedItem = Object.assign({}, this.newItem);
						this.successBarcode = true;
						this.$store.commit('goods/setBarcodeError', false);
						this.$emit('success', temp);
						this.loading = false;
						setTimeout(() => {
							if (this.newItem.wrapped) {
								this.isWrapped = true;
							} else {
								this.isWrapped = false;
							}
							Object.assign(this.newItem, initial);
							this.dropDowns.product.value = null;
							this.$store.commit('warehouse/resetCurrentItemBalance');
							this.unitName = '';
							if (this.newItem.incomingPriceUsd) {
								this.newItem.incomingPriceUsd = null
							}
							if (this.newItem.incomingPriceUzs) {
								this.newItem.incomingPriceUzs = null
							}
							this.newItem.priceUsd = null;
							this.newItem.priceUzs = null
						}, 100);
					} else {
						await WhDocument.storeItem(this.newItem).then(response => {
							this.lastAddedItem = Object.assign({}, response.data);
							this.successBarcode = true;
							this.$store.commit('goods/setBarcodeError', false);
							response.data.inventoryNum = this.dropDowns.product.value.count1;
							this.$emit('success', response.data);
							this.loading = false;
							setTimeout(() => {
								if (this.newItem.wrapped) {
									this.isWrapped = true;
								} else {
									this.isWrapped = false;
								}
								Object.assign(this.newItem, initial);
								this.dropDowns.product.value = null;
								// this.balance = 0;
								this.$store.commit('warehouse/resetCurrentItemBalance');
								this.unitName = '';
								if (this.newItem.incomingPriceUsd) {
									this.newItem.incomingPriceUsd = null
								}
								if (this.newItem.incomingPriceUzs) {
									this.newItem.incomingPriceUzs = null
								}
								this.newItem.priceUsd = null;
								this.newItem.priceUzs = null
							}, 100);
						}).catch((error) => {
							this.lastAddedItem = null;
							this.successBarcode = false;
							this.loading = false;
						})
					}
				}
			} else {
				this.$vs.notify({
					time: 1200,
					title: this.$t('please-select-product'),
					color: 'warning',
					icon: 'close',
					position: 'top-right'
				});
				this.itemFieldsNotFilled = true;
			}
		},
		openCancelExcelModal() {
			this.cancelExcelModal = true;
		},
		openCancelExcelVendorModal() {
			this.cancelExcelVendorModal = true;
		},
		async cancelLastUploaded(makeFileNull) {
			if (this.isTransfer) {
				this.excelFile = null;
			} else {
				if (makeFileNull) {
					this.newItem.excelFile = null;
					this.newItem.excelBarcodeFile = null;
				}
				await this.$emit('cancelExcel');
			}
		},
		async cancelVendorUploaded(makeFileNull) {
			if (this.isTransfer) {
				this.vendor = null;
			} else {
				if (makeFileNull) {
					this.newItem.vendor = null;
				}
				await this.$emit('cancelExcel');
			}
		},
		async uploadFileToServer() {
			let vm = this;

			// await this.cancelLastUploaded(false);
			this.$validator.validate().then(async function (valid) {

				if (true) {
					if (vm.isKirim) {
						vm.loading = true
						vm.fileNotSelectMessage = false;
						vm.fileSelected = true;
						let formData = new FormData()
						formData.append('upload', vm.newItem.excelFile)
						let payload = {
							formData: formData,
							docId: vm.documentId
						}
						vm.isExcelDisabled = true;
						await vm.uploadExcelForIncome(payload);
						vm.isExcelDisabled = false;
						vm.$emit('successExcel');
						vm.loading = false
					} else if (vm.isSpisat) {
						if (vm.department) {
							vm.loading = true
							vm.fileNotSelectMessage = false;
							vm.fileSelected = true;
							let formData = new FormData()
							formData.append('upload', vm.newItem.excelFile)
							let payload = {
								formData: formData,
								docId: vm.documentId,
								depId: vm.department
							}
							vm.isExcelDisabled = true;
							await vm.uploadExcelForSpisat(payload);
							vm.isExcelDisabled = false;
							vm.$emit('successExcel');
							vm.loading = false
						} else {
							vm.$vs.notify({
								title: 'Заполните все обязательные поля!',
								color: 'danger',
								icon: 'close',
								position: 'top-right'
							});
							return 0;
						}
					} else if (vm.isTransfer) {
						vm.loading = true
						vm.fileNotSelectMessage = false;
						vm.fileSelected = true;
						let formData = new FormData()
						formData.append('upload', vm.excelFile)
						let payload = {
							formData: formData,
							depId: vm.customDepartments.fromDepartmentId,
							docId: vm.documentId
						}
						vm.isExcelDisabled = true;
						await vm.uploadExcelForTransfer(payload);
						vm.isExcelDisabled = false;
						vm.$emit('successExcel');
						vm.loading = false
					}
				} else {
					vm.fileNotSelectMessage = true;
					vm.fileSelected = false;
				}
			});
		},

		async uploadFileToServerByBarcode() {
			let vm = this;
			this.$validator.validate().then(async function (valid) {
				if (vm.newItem.excelBarcodeFile) {
					if (vm.isSpisat) {
						if (vm.department) {
							vm.loading = true;
							vm.fileNotSelectMessage = false;
							vm.fileSelected = true;
							let formData = new FormData();
							formData.append('upload', vm.newItem.excelBarcodeFile);
							let payload = {
								formData: formData,
								docId: vm.documentId,
								depId: vm.department
							};
							vm.isExcelDisabled = true;
							let res = await vm.uploadExcelForSpisatByBarcode(payload);
							vm.isExcelDisabled = false;
							if (res) {
								vm.$emit('successExcel');
								if (vm.foundItemsFromXls && vm.foundItemsFromXls.some(x => x._rowVariant === 'danger')) {
									vm.$vs.notify({
										time: 6000,
										title: 'Внимание!',
										text: 'Некоторые товары загружены с недостаточным остатком (выделены красным)',
										color: 'warning',
										icon: 'warning',
										position: 'top-right'
									});
								}
							}
							vm.loading = false;
						} else {
							vm.$vs.notify({
								title: 'Заполните все обязательные поля!',
								color: 'danger',
								icon: 'close',
								position: 'top-right'
							});
							return 0;
						}
					}
				} else {
					vm.fileNotSelectMessage = true;
					vm.fileSelected = false;
				}
			});
		},

		async uploadFileToVendorServer() {
			let vm = this;
			// await this.cancelLastUploaded(false);
			this.$validator.validate().then(async function (valid) {
				if (vm.newItem.vendor) {
					if (vm.isKirim) {
						vm.loading = true
						vm.fileNotSelectMessage = false;
						vm.fileSelected = true;
						let formData = new FormData()
						formData.append('upload', vm.newItem.vendor)
						let payload = {
							formData: formData,
							docId: vm.documentId
						}
						vm.isExcelDisabled = true;
						await vm.uploadExcelForVendorIncome(payload);
						vm.isExcelDisabled = false;
						vm.$emit('successExcel');
						vm.loading = false
					} else if (vm.isSpisat) {
						if (vm.department) {
							vm.loading = true
							vm.fileNotSelectMessage = false;
							vm.fileSelected = true;
							let formData = new FormData()
							formData.append('upload', vm.newItem.vendor)
							let payload = {
								formData: formData,
								docId: vm.documentId,
								depId: vm.department
							}
							vm.isExcelDisabled = true;
							await vm.uploadExcelForSpisat(payload);
							vm.isExcelDisabled = false;
							vm.$emit('successExcel');
							vm.loading = false
						} else {
							vm.$vs.notify({
								title: 'Заполните все обязательные поля!',
								color: 'danger',
								icon: 'close',
								position: 'top-right'
							});
							return 0;
						}
					} else if (vm.isTransfer) {
						vm.loading = true
						vm.fileNotSelectMessage = false;
						vm.fileSelected = true;
						let formData = new FormData()
						formData.append('upload', vm.vendor)
						let payload = {
							formData: formData,
							depId: vm.customDepartments.fromDepartmentId,
							docId: vm.documentId
						}
						vm.isExcelDisabled = true;
						await vm.uploadExcelForTransfer(payload);
						vm.isExcelDisabled = false;
						vm.$emit('successExcel');
						vm.loading = false
					}
				} else {
					vm.fileNotSelectMessage = true;
					vm.fileSelected = false;
				}
			});

		},

		/*loadBalance(item) {
			WhDocument.balanceByItem(this.department, item).then(response => {
				this.balance = response.data;
				this.pushable = this.balance > 0;
			});
		},*/
		async loadLastPrice(item, fromWhere) {
			let pricingItemPayload = {
				itemId: item.id,
				department: this.department,
				type: this.depSaleType
			};
			//await this.lastPriceByItemId(pricingItemPayload);
			// if(((this.isTransfer && this.depSaleType) || this.isSpisat) && (this.isBarcodeScanned || this.barcodeFn)){
			// 	await this.loadNewBalance(pricingItemPayload);
			// }
			if (!this.isKirim) {
				if (this.depSaleType || !this.isTransfer) {
					// if (!this.barcodeFn && !this.isBarcodeScanned){
					let secondPriceArray = this.parseAndFilterStringToArray(item.secondPrice);
					let incomePriceArray = this.parseAndFilterStringToArray(item.incomingPriceUzs);
					if (this.depSaleType == 'WHOLE') {
						this.newItem.priceWholesale = item.price;
						this.newItem.priceUzs = secondPriceArray[0];
					} else if (this.depSaleType == 'RETAIL') {
						this.newItem.priceUzs = item.price;
						this.newItem.priceWholesale = secondPriceArray[0];
					}
					this.newItem.price = item.price
					this.newItem.incomingPriceUzs = incomePriceArray[0];
					// } else {
					// 	this.newItem.priceUzs = await this.pricingItem.priceUzs ? this.pricingItem.priceUzs : null;
					// 	this.newItem.priceWholesale = await this.pricingItem.priceWholesale ? this.pricingItem.priceWholesale : null;
					// 	this.newItem.incomingPriceUzs = await this.pricingItem.incomePriceUzs ? this.pricingItem.incomePriceUzs : null;
					// 	this.newItem.price = this.pricingItem.price;
					// }
				}
				// this.newItem.priceUzs = await this.pricingItem.priceUzs ? this.pricingItem.priceUzs : null;
				// this.newItem.priceWholesale = await this.pricingItem.priceWholesale ? this.pricingItem.priceWholesale : null;
				// this.newItem.incomingPriceUzs = await this.pricingItem.incomePriceUzs ? this.pricingItem.incomePriceUzs : null;
				// this.newItem.price = this.pricingItem.price;
			}
			if (this.barcodeFn || this.isBarcodeScanned) {
				// this.successBarcode = true;
				if (!this.isKirim) {
					// let itemBalancePayload = {
					// 	itemId: this.newItem.itemId,
					// 	department: this.department,
					// 	type: this.depSaleType
					// }
					//await this.loadNewBalance(itemBalancePayload);
					this.pushable = item.count1 > 0
				}
				if (fromWhere == 'fromBarcodeFn') {
					await this.addItem(fromWhere);
				} else {
					await this.addItem();
				}
				this.barcodeFn = false;
				this.isBarcodeScanned = false;
			}
			if (this.currentPricingItemError || this.currentItemBalanceError) {
				this.newItem.incomingPriceUzs = null;
				this.newItem.priceUzs = null;
				//this.$refs.incomingPriceRef.focus();
				this.barcodeFn = false;
				this.isBarcodeScanned = false;
			}
		},
		focusNextInput(fromInput) {
			if (fromInput == 'incomePrice') {
				if (!this.newItem.incomingPriceUzs || this.newItem.incomingPriceUzs == '') {
					this.$refs.incomingPriceRef.focus();
				} else {
					this.$refs.sellPriceRef.focus();
				}
			} else {
				if (!this.newItem.priceUzs || this.newItem.priceUzs == '') {
					this.$refs.sellPriceRef.focus();
				} else {
					this.$refs.newItemCountRef.focus();
				}
			}
			/*if (!this.newItem.incomingPriceUzs || this.newItem.incomingPriceUzs == '') {
				this.$refs.incomingPriceRef.focus();
			} else if (!this.newItem.priceUzs || this.newItem.priceUzs == '') {
				this.$refs.sellPriceRef.focus();
			} else {
				this.$refs.newItemCountRef.focus();
			}*/
		},
		itemBarcodeEntered(val) {
			if (!this.isBarcodeScanned) {
				clearTimeout(this.timeout);
				this.barcodeFn = true;
				let vm = this;
				this.timeout = setTimeout(async function () {
					if (!vm.department) {
						vm.noDepartment = true;
						vm.clearBarcodeInput();
						vm.focusBarcodeInput(1);
						vm.barcodeFn = false;
						return 0;
					}
					if (val.length > 3 && !vm.isBarcodeScanned) {
						vm.barcodeScanned(val);
						// vm.lastEnteredBarcode = val;
						// if (vm.isKirim) {
						// 	if (!vm.itemWithBarcode) {
						// 		await vm.fetchItemWithBarcode(val);
						// 	} else if (vm.itemWithBarcode.barcode !== val) {
						// 		await vm.fetchItemWithBarcode(val);
						// 	}
						// }

						// vm.clearBarcodeInput();
						// if (vm.itemWithBarcode) {
						// 	vm.unitName = vm.itemWithBarcode.unitName;
						// 	vm.newItem.itemId = vm.itemWithBarcode.id;
						// 	vm.newItem.itemName = vm.itemWithBarcode.name;
						// 	vm.newItem.count = 1;
						// 	vm.loadLastPrice(vm.itemWithBarcode);
						// 	// vm.$refs.barcodeItemCount.focus();
						// } else if (vm.barcodeError) {
						// 	vm.clearBarcodeInput();
						// 	vm.focusBarcodeInput(1);
						// 	vm.barcodeFn = false;
						// 	vm.successBarcode = false;
						// 	vm.$vs.notify({
						// 		time: 1200,
						// 		title: vm.$t('warehouse.document.itemNotFound'),
						// 		color: 'danger',
						// 		icon: 'close',
						// 		position: 'top-right'
						// 	});
						// }
					}
				}, 150);
			}
		}
		,
		async barcodeScanned(barcodeNum) {
				let barcode  = convertRuToEn(barcodeNum)
			if (this.itemWithDifferentPrices.length < 2 || this.isKirim) {
				this.isBarcodeScanned = true;
				this.barcodeFn = false;
				this.lastEnteredBarcode = barcode;
				if (!this.department) {
					this.noDepartment = true;
					this.clearBarcodeInput();
					this.focusBarcodeInput(1);
					this.isBarcodeScanned = false;
					this.successBarcode = false;
					return 0;
				}
				if (this.isBarcodeTab) {
					if (this.isKirim) {
						await this.fetchItemWithBarcode(barcode);
					} else {
						// let payload = {
						// 	barcode: barcode,
						// 	depId: this.department
						// };
						let obj = {
							keyword: barcode,
							depId: this.customDepartments.fromDepartmentId,
							depSaleType: this.depSaleType
						}
						//await this.fetchItemWithBarcodeNotIncome(payload)
						if (this.itemWithDifferentPrices.length < 1) {
							await this.fetchItemWithBarcodeScannerForDepBySaleType(obj);
						}
						if (this.itemWithDifferentPrices.length > 1) {
							this.playErrorSound();
							this.openCloseModalForItemWithDiffPrices(true);
							this.clearBarcodeInput();
							return 0;
						} else {
							this.openCloseModalForItemWithDiffPrices(false);
							if (this.itemNotFoundForDep) {
								this.playErrorSound();
								this.isBarcodeScanned = false;
								this.successBarcode = false;
								this.clearBarcodeInput();
								this.focusBarcodeInput(1);
								this.$vs.notify({
									time: 1200,
									title: this.$t('warehouse.document.itemNotFound'),
									color: 'danger',
									icon: 'close',
									position: 'top-right'
								});
							}
							this.clearBarcodeInput();
						}
					}
					this.clearBarcodeInput();
					if (this.itemWithBarcode) {
						this.isWrapped = this.itemWithBarcode.wrapped
						this.unitName = this.itemWithBarcode.unitName;
						this.newItem.itemId = this.itemWithBarcode.id;
						this.newItem.itemName = this.itemWithBarcode.name;
						this.newItem.count = 1;
						// this.newItem.termOfItem = this.itemWithBarcode.termOfItem;
						this.newItem.wrapped = this.itemWithBarcode.wrapped;
						this.newItem.barcode = this.itemWithBarcode.barcode;
						this.newItem.artikul = this.itemWithBarcode.artikul;
						this.newItem.color = this.itemWithBarcode.colorName;
						this.newItem.size = this.itemWithBarcode.size;
						this.newItem.docId = this.itemWithBarcode.docId
						if (this.newItem.wrapped) {
							await this.wrappedItemSelected(this.newItem);
							if (this.isKirim) {
								this.newItem.wrappedItems = this.viewItem;
							} else if (this.isTransfer) {
								this.newItem.whWrappedItems = this.viewItem;
							}
						}
						await this.loadLastPrice(this.itemWithBarcode, 'fromBarcodeFn');
						/*if (this.isTransfer) {
							await this.loadBalance(this.itemWithBarcode.id)
						}*/
						this.$refs.barcodeInput.focus();
						// vm.$refs.barcodeItemCount.focus();
					} else if (this.barcodeError) {
						this.playErrorSound();
						this.isBarcodeScanned = false;
						this.successBarcode = false;
						this.clearBarcodeInput();
						this.focusBarcodeInput(1);
						this.$vs.notify({
							time: 1200,
							title: this.$t('warehouse.document.itemNotFound'),
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					}
				}
			}
		},
		barcodeItemCountEntered() {
			if (this.newItem.count > 0) {
				this.addItem();
				this.$store.commit('goods/setItemWithBarcode', null);
				this.focusBarcodeInput(1);
			}
		}
		,
		focusBarcodeInput($event) {
			if ($event == 1) {
				// this.$barcodeScanner.init(this.itemBarcodeEntered);
				this.$refs.barcodeInput.focus();
				this.$store.commit('goods/setBarcodeTab', true);
				this.$refs.barcodeInput.$el.value = '';
				this.$refs.barcodeInput.focus();
			} else {
				// this.$barcodeScanner.destroy();
				this.$store.commit('goods/setBarcodeTab', false);
				this.newItem.incomingPriceUzs = null;
				this.newItem.priceUzs = null;
			}
		}
		,
		clearBarcodeInput() {
			this.barcodeInputValue = '';
			this.$refs.barcodeInput.$el.value = '';
		},
	},

	watch: {
		'department': {
			handler(newVal) {
				this.dropDowns.product.value = null;
				if (newVal) {
					if (this.isTransfer) {
						if (this.toDepartmentId) {
							this.bothDepsSelected = true;
						}
					}

					this.dropDowns.product.value = null;
					this.disableButton = true;
					this.newItem.priceUzs = null;
					this.loadItems(' ');
					this.loadSector(newVal)
				}
			}
		},
		'toDepartmentId': {
			handler(newVal) {
				if (newVal) {
					if (this.isTransfer) {
						if (this.department) {
							this.bothDepsSelected = true;
						}
					}
					this.dropDowns.product.value = null;
					this.disableButton = true;
					this.newItem.priceUzs = null;
					this.loadItems(' ');
				}
			}

		},
		'groupId': {
			handler(g) {
				if (this.department) {
					this.bothDepsSelected = true;
				}
				this.dropDowns.product.value = null;
				this.disableButton = true;
				this.newItem.priceUzs = null;
				this.loadItems(' ');
			}
		},
		'priceIsNotDifferent': {
			handler(newVal) {
				if (newVal === false && this.isTransfer) {
					this.openModalPriceDifference();
					this.dropDowns.product.value = null;
					this.disableButton = true;
					this.newItem.priceUzs = null;
					this.changePriceNotDifferent();
					this.barcodeFn = false;
					this.isBarcodeScanned = false;
				}
			}
		},
		'dropDowns.product.value': {
			async handler(newValue, oldValue) {
				if (oldValue == null) {
					this.disableButton = false;
				}
				if (newValue) {
					this.newItem.wrapped = newValue.wrapped;
					this.newItem.docId = newValue.docId;
					this.isWrapped = newValue.wrapped;
				}

				if (!this.department) {
					this.noDepartment = true;
					return 0;
				}
				this.noDepartment = false;
				if (!newValue) {
					this.unitName = '';
					this.newItem.incomingPriceUzs = null;
					this.newItem.priceUzs = null;
					// this.balance = 0;
					this.$store.commit('warehouse/resetCurrentItemBalance');
					return;
				}
				this.itemFieldsNotFilled = false;
				if ((this.sections.includes(this.section)) && this.department) {
					this.errorMessage = null;
					let itemBalancePayload = {
						itemId: newValue.id,
						department: this.department
					}
					//await this.loadBalance(itemBalancePayload);
					// if (this.balance > 0) {
					// 	this.newItem.count = 1;
					// } else {
					// 	this.newItem.count = 0;
					// }
					this.newItem.count = null;
					if (this.section == 'KOCHIRISH' || this.section == 'SPISAT') {
						if (this.section == 'KOCHIRISH') {
							if (newValue.wrapped) {
								if (newValue && oldValue) {
									if (newValue.id !== oldValue.id) {
										Vue.set(newValue, "itemId", newValue.id)
										await this.wrappedItemSelected(newValue);
									}
								} else {
									Vue.set(newValue, "itemId", newValue.id)
									await this.wrappedItemSelected(newValue);
								}
							}
						}
						this.loadLastPrice(newValue);
					}
					if (this.$refs.newItemCountRef) {
						this.$refs.newItemCountRef.focus();
					}
				} else if (this.sections.includes(this.section) && !this.department) {
					this.dropDowns.product.value = null;
					this.errorMessage = 'incomes.select-department'
				} else if (!this.sections.includes(this.section) && this.department) {
					if (newValue.wrapped) {
						if (newValue && oldValue) {
							if (newValue.id !== oldValue.id) {
								Vue.set(newValue, "itemId", newValue.id)
								await this.wrappedItemSelected(newValue);
							}
						} else {
							Vue.set(newValue, "itemId", newValue.id)
							await this.wrappedItemSelected(newValue);
						}
					}
					this.newItem.count = null;
					this.loadLastPrice(newValue);
				}
				/*if (!this.sections.includes(this.section) && this.department && newValue) {
					if (!this.newItem.incomingPriceUzs) {
						if(this.$refs.incomingPriceRef) {
							this.$refs.incomingPriceRef.focus();
						}
					} else if (!this.newItem.priceUzs) {
						if(this.$refs.sellPriceRef) {
							this.$refs.sellPriceRef.focus();
						}
					} else {
						if(this.$refs.newItemCountRef) {
							this.$refs.newItemCountRef.focus();
						}
					}
				}*/
				this.unitName = newValue.unitName;
				this.newItem.itemId = newValue.id;
				this.newItem.itemName = newValue.name;
				this.newItem.termOfItem = newValue.termOfItem;
				this.newItem.regNumber = newValue.regNumber;
			}
		},
		isBarcodeTab: {
			handler(newVal) {
				if (newVal) {
					// this.$barcodeScanner.init(this.barcodeScanned);
					this.$refs.barcodeInput.$el.value = '';
					this.$refs.barcodeInput.focus();
				} else {
					// this.$barcodeScanner.destroy();
				}
			}
		},
		noDepartment: {
			handler(newVal) {
				if (newVal) {
					this.$vs.notify({
						text: this.$t('department.choose-department'),
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
					this.dropDowns.product.value = null;
					this.noDepartment = false;
				}
			}
		},
		'newItem.priceUsd': {
			handler(newValue) {
				if (this.currencyRate !== -1 && this.convert) {
					this.newItem.priceUzs = newValue * this.currencyRate;
				}
			}
		},
		'newItem.incomingPriceUsd': {
			handler(newValue) {
				if (this.currencyRate !== -1 && this.convert) {
					this.newItem.incomingPriceUzs = newValue * this.currencyRate;
				}
			}
		},

		'newItem.incomingPriceUzs': {
			handler(newValue) {
				if (this.currencyRate !== -1 && this.convert) {
					this.newItem.incomingPriceUsd = newValue / this.currencyRate;
				}
			}
		},


		'newItem.priceUzs': {
			handler(newValue) {
				if (this.currencyRate !== -1 && this.convert) {
					this.newItem.priceUsd = newValue / this.currencyRate;
				}
			}
		},

		'newItem.count': {
			handler(newValue) {
				if (newValue) {
					if (this.dropDowns.product.value) {
						if (this.sections.includes(this.section) && newValue > this.dropDowns.product.value.count1) {
							setTimeout(() => {
								this.newItem.count = this.dropDowns.product.value.count1;
							}, 100);
						}
					}
				}
			}
		},
		'newItem.excelFile': {
			handler(newValue) {
				if (newValue === null) {
					this.fileSelected = null
				} else {
					this.fileNotSelectMessage = false
					this.fileSelected = true
				}

			}
		},
		'newItem.vendor': {
			handler(newValue) {
				if (newValue === null) {
					this.fileSelected = null
				} else {
					this.fileNotSelectMessage = false
					this.fileSelected = true
				}

			}
		},
		'excelFile': {
			handler(newValue) {
				if (newValue === null) {
					this.fileSelected = null
				} else {
					this.fileNotSelectMessage = false
					this.fileSelected = true
				}

			}
		},
		'vendor': {
			handler(newValue) {
				if (newValue === null) {
					this.fileSelected = null
				} else {
					this.fileNotSelectMessage = false
					this.fileSelected = true
				}

			}
		},
		'depSaleType': {
			handler(newValue, oldValue) {
				if (newValue && oldValue == null && this.mode == 'edit') {
					this.loadItems(' ');
				}
			}
		},
	},

	computed: {
		computedDepCurrencyName() {
			return this.depCurrencyName || this.incomeCurrency.name || this.userDepCurrencyName;
		},
		isWrappedComputed() {
			return this.isWrapped;
		},
		isXlsDisabled() {
			return this.isExcelDisabled;
		},
		...mapState(['userDepCurrencyName', 'isAdmin']),
		...mapState('goods', [
			'goodsForMultiselect', 'withKeywordError',
			'itemWithBarcode', 'barcodeError', 'isBarcodeTab', 'lastWrappedItems',
			'itemWithDifferentPrices', 'itemNotFoundForDep'
		]),
		...mapState('warehouse', [
			'pricingItem', 'balance', 'customDepartments',
			'currentItemBalanceError', 'currentPricingItemError', 'itemsNotKirim', 'priceIsNotDifferent',
			'foundItemsFromXls', 'notFoundItemsFromXls', 'depSaleType'
		]),
		isKirim() {
			return this.section === 'KIRIM';
		},
		isChiqim() {
			return this.section === 'CHIQIM';
		},
		isTransfer() {
			return this.section === 'KOCHIRISH';
		},
		isSpisat() {
			return this.section === 'SPISAT';
		},
		showUnit() {
			return (this.unitName) ? ` (${this.unitName})` : ``;
		},
		isEnable() {
			return (this.loading || !this.pushable || this.newItem.count < 1) && this.unitName !== null;
		}
	}
}
</script>

<style scoped lang="scss">
.itemWithDifferentPrices {
	padding: 10px;
	cursor: pointer;

	&:hover {
		background-color: #ccc;
	}
}

.form-wrapper {
	position: relative;
	padding: 15px;
	border-bottom: 1px solid #e1e1e1;
	margin: 15px 0;
	border-top: 1px solid #e1e1e1;
}

.spinner-wrapper {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	text-align: center;
	background: rgba(0, 0, 0, 0.09);
	bottom: 0;
	z-index: 2;
	padding-top: 60px;
}

.generalTableClass {
	max-height: 500px;
	overflow-y: scroll;
}

.generalTableClass thead tr {
	th, td {
		&.width18 {
			width: 18% !important;
		}
	}
}
</style>
